import { Duration } from "luxon";

export const toHumanFixed = (duration) => {
  // see: https://github.com/moment/luxon/issues/1134
  const vals = duration.toObject();
  const fullD = Duration.fromObject({
    days: vals.days || 0,
    hours: vals.hours || 0,
    minutes: vals.minutes || 0,
    seconds: vals.seconds || 0,
  }).normalize();
  const newVals = {};
  for (const [key, value] of Object.entries(fullD.toObject())) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return Duration.fromObject(newVals).toHuman();
}
